export default __webpack_public_path__ + "static/media/icn_wheel.fef7d2e5.svg";